/**
 * 不明なパスアクセス時に表示するコンポーネント
 * @function
 * @returns {JSX.Element}
 */
export const NoMatch = () => {
  return <h2>このページは存在しません。</h2>;
};
